import { ZodiacTypes } from '@packages/shared/core/zodiac/entities';
import { PagePath } from '../constants/routes';
import { joinUrls } from './url';

const CANONICAL_ZODIAC_PAIRS = new Set<string>([
  'aquarius/cancer',
  'aquarius/leo',
  'aquarius/libra',
  'aquarius/pisces',
  'aquarius/sagittarius',
  'aquarius/scorpio',
  'aries/aquarius',
  'aries/cancer',
  'aries/capricorn',
  'aries/gemini',
  'aries/sagittarius',
  'aries/scorpio',
  'aries/taurus',
  'cancer/capricorn',
  'cancer/leo',
  'cancer/libra',
  'cancer/pisces',
  'cancer/sagittarius',
  'cancer/scorpio',
  'cancer/virgo',
  'capricorn/aquarius',
  'capricorn/gemini',
  'gemini/aquarius',
  'gemini/cancer',
  'gemini/libra',
  'gemini/pisces',
  'gemini/sagittarius',
  'gemini/scorpio',
  'gemini/virgo',
  'leo/aries',
  'leo/capricorn',
  'leo/gemini',
  'leo/libra',
  'leo/pisces',
  'leo/sagittarius',
  'leo/scorpio',
  'leo/taurus',
  'leo/virgo',
  'libra/aries',
  'libra/capricorn',
  'libra/sagittarius',
  'libra/scorpio',
  'pisces/aries',
  'pisces/capricorn',
  'pisces/libra',
  'sagittarius/capricorn',
  'sagittarius/pisces',
  'scorpio/capricorn',
  'scorpio/pisces',
  'scorpio/sagittarius',
  'scorpio/virgo',
  'taurus/aquarius',
  'taurus/cancer',
  'taurus/capricorn',
  'taurus/gemini',
  'taurus/libra',
  'taurus/pisces',
  'taurus/sagittarius',
  'taurus/scorpio',
  'taurus/virgo',
  'virgo/aquarius',
  'virgo/aries',
  'virgo/capricorn',
  'virgo/libra',
  'virgo/pisces',
  'virgo/sagittarius',
]);

export function getZodiacCompatibilityPairCanonicalUrl(zodiac1: ZodiacTypes, zodiac2: ZodiacTypes): string {
  const pair = joinUrls(zodiac1, zodiac2);
  const reversePair = joinUrls(zodiac2, zodiac1);
  const canonicalPath = CANONICAL_ZODIAC_PAIRS.has(pair) ? pair : reversePair;
  return joinUrls(PagePath.ZODIAC_COMPATIBILITY, canonicalPath);
}
